import React, { Component } from 'react';
import { Wrapper } from 'components/ui/index';
class MultiDragContainer extends Component {
  render() {
    return (
      <Wrapper />
    );
  }
}
export default MultiDragContainer;


// WEBPACK FOOTER //
// ./src/views/ui-demo/component/MultiDragContainer.jsx